const getErrorsString = () => {
  const errorsString = {
    errorMessageGeneric: "Generic error.",
    errorMessageCarousel: "Not carousel configured",
    noItemsFound: "No items found",
    noImagesToDownload: "No images to download",
    noPermission: "You do not have permission to view this content",
    errorMessageLogout: "Error on Logout",
    missingUuid: "Missing uuid",
  };
  return errorsString;
};

export default getErrorsString();
